import { useApiQuery } from 'hooks/useApiQuery'

export const useGetAllLicensedEstablishments = ({
  currentStateId = 0,
}: {
  currentStateId: number
}) =>
  useApiQuery({
    method: 'get',
    path: '/admin/corporate-accounts/licensed-establishments',
    queryKey: ['licensed-establishments'],
    queryArgs: {},
    requestHeaders: currentStateId
      ? { 'Current-State-Id': currentStateId.toString() }
      : undefined,
  })
